/**
 * @nubeteck/formeck (0.19.5)
 * Copyright (c) Nubeteck, SRL.
 */
import { b as o, a as n, g as a } from "./currency-utils.DnRSwher.js";
import { N as c } from "./constants.CLW3UOOg.js";
const s = () => {
  if (typeof window < "u" && window.localStorage) {
    const r = window.localStorage.getItem(
      c
    );
    if (typeof r == "string")
      return JSON.parse(r)?.currencyIso;
  }
  return "DOP";
}, f = {
  percentage: (r) => `${r ?? 0}%`,
  number: (r, e) => o(r, { precision: e }).format({ symbol: "" }),
  currency: (r, e) => n(r, e).format({
    symbol: a(`${s()}`)
  })
}, i = (r, e, t) => f[r](e, t ?? 2) ?? 0, l = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  format: i
}, Symbol.toStringTag, { value: "Module" }));
export {
  i as a,
  l as f
};
